import React, { useEffect } from 'react';

/**
 * PageTitleManager Component
 * Ensures the document title is always "Pyxi" on web
 * This component should be placed at the top level of the app
 */
const PageTitleManager: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    // Set title to Pyxi
    document.title = 'Pyxi';

    // Create a proxy for document.title to intercept writes
    const titleDescriptor = Object.getOwnPropertyDescriptor(document, 'title');
    
    Object.defineProperty(document, 'title', {
      get() {
        return 'Pyxi';
      },
      set(value: string) {
        console.log('🌐 [WEB] Attempted to change title to "' + value + '", keeping as "Pyxi"');
        // Do nothing - always keep it as "Pyxi"
      },
      configurable: true,
    });

    // Cleanup function to restore original descriptor if needed
    return () => {
      if (titleDescriptor) {
        Object.defineProperty(document, 'title', titleDescriptor);
      }
    };
  }, []);

  return <>{children}</>;
};

export default PageTitleManager;
